import { useMemo } from 'react';

import { useUpsellCartEntries } from '@fhs/cart/src/queries/use-upsell-cart-entries';
import { useOrderContext } from 'state/order';

import { existsInEntries } from './utils';

export const useMenuFeatureUpsell = () => {
  const { cartEntries } = useOrderContext();

  const upsellCartEntriesQuery = useUpsellCartEntries();

  const items = useMemo(
    () =>
      (upsellCartEntriesQuery.data ?? [])
        .filter(
          item =>
            // Check if doesn't exists in the cart
            !existsInEntries(item, cartEntries)
        )
        .slice(0, 2),
    [cartEntries, upsellCartEntriesQuery.data]
  );

  return {
    items,
    loading: upsellCartEntriesQuery.isLoading,
  };
};
